import { API_PATHS } from "../constants/api-paths";
import { IEFInsert } from "../types/sso.types";
import { encryptedRequest } from "../core/api.client";

export const iefInsertApi = async (data: IEFInsert) => {
  const response = await encryptedRequest<IEFInsert>({
    method: "POST",
    url: API_PATHS.iefInsert,
    data,
  });

  return response;
};
